import api from 'ApiConfig';

const jobServices = {
  getAssignedJobs: async () => {
    return api.post('/student/assigned-jobs');
  },

  markJobAsViewed: async (assignmentId) => {
    return api.post('/student/mark-job-viewed', { assignmentId });
  },

  studentRevertJobOffer: async (assignmentId, revert, offerDetails, reason) => {
    return api.post('/student/revert', { assignmentId, revert, offerDetails, reason });
  },
  autoDeclineCheck: async (assignmentId) => {
    return api.post('/student/auto-decline', { assignmentId });
  },
  checkAssignmentExpiry: async (assignmentId) => {
    return api.post('/student/check-assignment-expiry', { assignmentId });
  },
  updateStudentRoundStatus: async (
    assignmentId,
    roundNumber,
    studentStatus
  ) => {
    return api.post('/student/round-revert', {
      assignmentId,
      roundNumber,
      studentStatus,
    });
  },

  markNotificationAsRead: async (notificationId) => {
    return api.post('/student/notifications/read', { notificationId });
  },
  markAllNotificationsAsRead: async () => {
    return api.post('/student/notifications/read-all');
  },
  addFeedbackAndQuestions: async (data) => {
    return api.post('/student/add-assigned-job-feedback', data);
  },
  getFeedback: async (jobAssignmentId) => {
    return api.post('/student/get-assigned-job-feedback', { jobAssignmentId });
  },
  deleteQuestion: async (data) => {
    return api.post('/student/delete-assigned-job-feedback', data);
  },
  updateQuestion: async (data) => {
    return api.post('/student/update-assigned-job-feedback', data);
  },
  pausePlacement: async (pauseDetails) => {
    return api.post('/student/pause-placement', { pauseDetails });
  },
  getPauseStatus: async () => {
    return api.get('/student/get-placment-paused-status');
  },
  unpausePlacement: async () => {
    return api.get('/student/unpaused-placement');
  },
  studentGetPlacementOverview: async () => {
    return api.post('/student/get-students-placement-overview');
  },
  requestUnpausePlacement: async (unpauseReason) => {
    return api.post('/student/request-unpaused-placement', unpauseReason);
  },
  getStudentOfferDetails: async () => {
    return api.post('/student/get-offer-details');
  },
  respondToJobAssignment: async (assignmentId, response, reason) => {
    return api.post('/student/respond-job-assignment', { assignmentId, response, reason });
  },
  uploadResume: async (formData) => {
    return api.post('/student/upload-resume', formData);
  },
  getResume: async () => {
    return api.get('/student/get-resume');
  },
  deleteResume: async (type) => {
    return api.delete('/student/delete-resume', { params: { type } });
  },
};

export default jobServices;
